<template>
  <div>
    <v-app-bar color="primary accent-4" dark dense>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn icon>
        <img
          src="@/assets/svg/betslip.svg"
          @click.stop="drawer_cart = !drawer_cart"
          style="width: 25px"
        />
        <!--        <v-icon @click.stop="drawer_cart = !drawer_cart">mdi-dots-vertical</v-icon>-->
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      left
      temporary
      width="100%"
      class="nav-mobile"
    >
      <v-row>
        <v-col cols="12" class="text-right pt-4 pr-4 pb-0">
          <v-spacer></v-spacer>
          <v-icon @click.stop="drawer = !drawer">mdi-close</v-icon>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          class="bordered-element left-module-mobile"
        >
          <LeftModule></LeftModule>
        </v-col>
      </v-row>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="drawer_cart"
      absolute
      top
      temporary
      height="100%"
      width="100%"
      style="margin-top: 15%"
    >
      <v-row>
        <v-col cols="12" class="text-right pt-4 pr-4 pb-0">
          <v-spacer></v-spacer>
          <v-icon @click.stop="drawer_cart = !drawer_cart">mdi-close</v-icon>
        </v-col>
        <v-col cols="12" sm="2" md="2" class="bordered-element">
          <RightModule></RightModule>
        </v-col>
      </v-row>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LeftModule from '@/components/Left.vue'
import Search from '@/components/generic/Search'
import CenterModule from '@/components/Center'
import RightModule from '@/components/Right'

export default {
  name: 'MenuMobile',
  data: () => ({
    drawer: false,
    drawer_cart: false,
  }),
  components: {
    Search,
    LeftModule,
    CenterModule,
    RightModule,
  },
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getId: 'user/getId',
      getLogin: 'user/getLogin',
    }),
  },
  methods: {
    ...mapActions({}),
  },
  async mounted() {},
}
</script>
